export default "__VITE_ASSET__CtlpPlV3__"